<template>
  <div class="d-flex flex-column">
    <div
      class="showing-div"
      style="margin-left: 40px; color:#006C6B !important;font-weight: bold;"
      v-if="applicantsCount.total != 0"
    >
      <template v-if="applicantsCount.total === 1">
        1名表示 / 1名登録
      </template>
      <template v-else>
        {{ applicantsCount.from }}-{{ applicantsCount.to }}名表示 / 登録者全体{{
          applicantsCount.total
        }}名
      </template>
    </div>
    <div class="listing-type-one d-xl-flex flex-wrap justify-content-start">
      <div :class="class1">
        <div>
          <input
            type="checkbox"
            v-model="isCheckAll"
            @click="checkAll()"
            style="width: 18px;height: 18px;margin-left: 5px;"
          />
        </div>
        <div class="col-sm-2 ml-4 text-center">
          <div class="d-flex">
            <b-dropdown
              id="actionDropdown"
              :text="selectedLabel"
              class="btn-sm-drop dd-button mr-2"
              @shown="$emit('shown')"
              @hidden="$emit('hidden')"
              variant="secondary"
            >
              <b-dropdown-item
                @click="executeBulkAction('スカウト対象外にする')"
              >
                スカウト対象外にする
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </div>
      <!-- Additional Action Buttons -->
      <div class="col-sm-3 text-center">
        <div class="d-flex">
          <TemplateListButton
            :btnClass="'btn custom-blue-btn common-btn ml-4'"
            :label="'テンプレート一覧'"
            @click="showScoutTemplate"
          />

          <!-- <FilterDropdown
            ref="userFilterDropdown"
            :users="assignedUsers"
            :initialSelectedId="scoutedBy"
            @apply="handleUserFilterApply"
            @hidden="handleUserFilterHidden"
          /> -->
          <button
            v-if="scoutedBy"
            class="btn custom-gray-btn common-btn text-black ml-4"
            @click="clearFilters"
          >
            絞り込みクリア
          </button>
        </div>
      </div>
    </div>
    <MessageTemplate ref="templateModal" />
    <!-- ends listing-type-one -->
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex';

import Api from '@/config/api';
import ApiService from '@/service/apiService';
import MessageTemplate from '../contacts/MessageTemplate/MessageTemplate.vue';
import MessageTemplateModal from '../contacts/MessageTemplate/MessageTemplateModal.vue';
import FilterDropdown from './FilterDropdown.vue';
import TemplateListButton from '@/components/common/TemplateListButton.vue';

export default {
  name: 'ScoutApplicantsBar',
  components: {
    // SearchTemplateModal,
    // Csv,
    MessageTemplateModal,
    MessageTemplate,
    FilterDropdown,
    TemplateListButton,
  },
  data() {
    return {
      class1:
        'one-left d-xl-flex align-items-center justify-content-center justify-content-md-start',
      title: '',
      errors: {
        title: {
          error: false,
          msg: '',
        },
      },
      isSubmitting: false,
      selectedLabel: '▼ 一括操作',
      showMessageTemplateModal: false,
      clientUsers: [],
      selectedUserId: null,
    };
  },
  computed: {
    ...mapState({
      checkAllState: ({ applicant }) => applicant.isCheckAll,
      jobseekerIds: ({ applicant }) => applicant.jobseekerIds,
      loading: ({ applicant }) => applicant.loading,
    }),
    isCheckAll: {
      get() {
        return this.checkAllState; // Get value from Vuex state
      },
      set(value) {
        this.setCheckAll(value); // Trigger mutation when value changes
      },
    },
    scoutedBy: {
      get() {
        return this.getScoutedBy; // Get value from Vuex state
      },
      set(value) {
        this.setScoutedBy(value); // Trigger mutation when value changes
      },
    },
    ...mapGetters({
      applicantsCount: 'getApplicantCounts',
      isReviewer: 'isCreateReviewUser',
      // users: 'getAllUsers',
      assignedUsers: 'getAllAssignedUsers',
      getScoutedBy: 'getScoutedBy',
    }),
    checkSelectedLabel() {
      return this.selectedLabel === '一括操作　　▼';
    },
  },
  methods: {
    ...mapMutations([
      'setCheckAll',
      'setLoading',
      'mutateApplicantsAfterMultipleStatus',
      'setJobseekerIds',
      'setReloadApplicants',
      'setSearchParams',
      'setScoutedBy',
    ]),
    ...mapActions({
      // loadAllUsers: 'loadAllUsers',
      loadAssingedUsers: 'loadAssingedUsers'
    }),
    showScoutTemplate() {
      this.$refs.templateModal.show();
      // this.showMessageTemplateModal = true;
    },
    hideScoutTemplate() {
      this.showMessageTemplateModal = false;
    },
    checkAll() {
      if (this.isCheckAll) {
        this.setCheckAll(true);
      } else {
        this.setCheckAll(false);
      }
    },
    executeBulkAction(action) {
      this.selectedLabel = action;
      if (action === 'スカウト対象外にする') {
        this.removeFromScout();
      }
    },
    handleUserFilterApply(selectedUserId) {
      if (selectedUserId) {
        // Set searchParams in Vuex store for scoutedBy filter
        this.setScoutedBy(selectedUserId);
      }
    },
    handleUserFilterHidden() {
      // Handle when dropdown is hidden
      // console.log('User filter dropdown hidden');
    },
    clearFilters() {
      // Clear searchParams including scoutedBy filter
      this.setScoutedBy(null);
      // Reset the FilterDropdown component
      if (this.$refs.userFilterDropdown) {
        this.$refs.userFilterDropdown.selectedUserId = null;
      }
    },
    removeFromScout() {
      this.errors = [];

      if (this.jobseekerIds.length == 0) {
        return;
      } else {
        // this.loading = true;
        this.setLoading(true);
        // this.loading = true;
        ApiService.put(Api.endpoints.MULTIPLE_STATUS, {
          jobseekerIDs: this.jobseekerIds,
          status: '未確認',
        })
          .then(({ data }) => {
            // console.log(data.data)
            // this.mutateApplicantsAfterMultipleStatus(data.data);
            this.setCheckAll(false);
            this.setReloadApplicants(true);
            // this.loading = false;
          })
          .catch((error) => console.log(error))
          .then(() => {
            // this.loading = false;
            this.setJobseekerIds([]);
            this.setCheckAll(false);
            // this.loading = false;
            // this.setLoading(false);
          });
      }
    },
  },
  mounted() {
    // this.loadAllUsers();
    this.loadAssingedUsers();
  },
  watch: {
    title(value) {
      if (value === '') {
        this.errors.title.error = true;
        this.errors.title.msg = '検索条件名は必須項目です';
      } else {
        this.errors.title.error = false;
        this.errors.title.msg = '';
      }
    },
  },
};
</script>
<style scoped>
.scout-btn {
  background-color: #006c6b;
  color: #ffffff;
  border: none;
  padding: 10px;
  border-radius: 5px;
  margin-right: 20px;
}

.scout-btn:hover {
  opacity: 0.8;
  color: #ffffff;
}

.template-modal .modal-body {
  padding: 0px !important;
}
.btn-plain.template-Btn {
  background-color: #ffffff;
  min-width: 30px;
  width: 30px;
}
table th {
  text-align: center;
}
table td {
  text-align: center;
}
.nostyle li {
  margin-right: 10px;
  padding-right: 10px;
}
>>> .dropdown-menu.show {
  width: 200px;
  min-width: 200px;
  color: #ff0000;
}
>>> .dropdown-item {
  font-size: 14px;
  color: #ff0000;
  padding: 5px 10px !important;
}
>>> .dropdown-item:hover {
  color: #006c6b !important;
  background-color: #fff;
}
>>> .dropdown .btn-secondary {
  background-color: #fff !important;
  color: #3c3c3c !important;
  height: 50px !important;
  min-width: 200px !important;
  width: 200px !important;
  border-radius: 30px;
}
.bulk-action-btn {
  width: 56px;
  min-width: 56px;
  height: 37px;
  background: #d9d9d9;
  font-size: 14px;
  border-radius: 4px;
  color: #3c3c3c;
  border: 1px solid #3c3c3c;
}
.bulk-action-btn::hover {
  opacity: 0.2;
}
.btn-heart i {
  font-size: 25px !important;
}
i {
  font-size: 25px !important;
}
.favorite-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.favorite-wrapper.favorite-border {
  border: 1px solid #787878;
  width: 116px;
  height: 50px;
  border-radius: 4px;
}

.btn-success {
  background: #52a352;
  border: #52a352;
  height: 40px;
  line-height: 10px;
  margin: auto;
}
.favorite-wrapper span {
  font-size: 14px;
  margin-top: 5px;
  font-weight: 500;
  color: #3c3c3c;
}
.btn-search {
  height: 50px;
  line-height: 10px;
  margin: auto;
  border-radius: 5px;
}
.btn-clear {
  background-color: #dae0e3;
  border-color: #dae0e3;
  color: #717c85 !important;
  font-weight: 500;
  height: 40px;
  line-height: 10px;
  margin: auto;
  border-radius: 5px;
}

.btn-clear:hover,
.btn-clear:focus {
  background-color: #c2c9cc !important;
  border-color: #c2c9cc !important;
}
.one-right .btn-heart:hover i {
  color: #aba2a2;
}

/* Common button styles */
.common-btn {
  min-width: 200px !important;
  width: 200px !important;
  border-radius: 30px;
  height: 50px !important;
  padding: 0px !important;
}

.custom-blue-btn {
  background-color: #036ac9 !important;
  border-color: #036ac9 !important;
  color: white !important;
}
.custom-blue-btn:hover {
  background-color: #0255a3 !important;
  border-color: #0255a3 !important;
  color: white !important;
}
/* .custom-secondary-btn {
    background-color: #006C6B !important;
    border-color: #006C6B !important;
    color: white !important;
  }
  .custom-secondary-btn:hover {
    background-color: #005a59 !important;
    border-color: #005a59 !important;
    color: white !important;
  } */
</style>
